import React from "react";
import {
  ClientAddress,
  ClientAddressWrapper,
  ClientCity,
  ClientImage,
  ClientInfoWrapper,
  ClientName,
  ClientPhotoCityWrapper,
  ClientPhotoWrapper,
  SignedContract,
  Wrapper,
} from "./styles";

import clientLoc from "../../../../../../assets/pages/NewHome/ClientsSection/client-loc.jpeg";

function ClientCard() {
  return (
    <Wrapper>
      <ClientInfoWrapper>
        <ClientAddressWrapper>
          <ClientAddress>Rua Ana Bilhar, Apto 301 - Meireles</ClientAddress>
          <ClientName>Ana Júlia</ClientName>
        </ClientAddressWrapper>
        <ClientPhotoCityWrapper>
          <ClientPhotoWrapper>
            <ClientImage src={clientLoc} />
          </ClientPhotoWrapper>
          <ClientCity>Fortaleza, CE</ClientCity>
        </ClientPhotoCityWrapper>
      </ClientInfoWrapper>
      <SignedContract>Contrato Assinado</SignedContract>
    </Wrapper>
  );
}

export default ClientCard;
